import { createApi } from '@reduxjs/toolkit/query/react'
import { NetWork } from '../../../../common/apiKey'
import { DELETE, GET, PATCH, POST, PUT } from '../../../../common/contants'
import { ReponseData2 } from '../../../../types'
import { CostRoadType } from '../../../../types/genusHistory/costRoad'
import { axiosBaseQuery } from '../../../baseQuery'

export const costRoadApi = createApi({
  reducerPath: 'costRoadApi',
  baseQuery: axiosBaseQuery,
  tagTypes: ['CostRoad'],
  endpoints: (builder) => ({
    getListCostRoad: builder.query({
      query: (params) => ({
        url: NetWork.costRoad,
        method: GET,
        params: params,
        providesTags: (result: ReponseData2<{ rows: CostRoadType[] }>) =>
          result ? [{ type: 'CostRoad', id: 'LIST' }] : []
      })
    }),
    getCostRoadById: builder.query({
      query: (params: { costRoadId: number }) => ({
        url: NetWork.costRoadId(params.costRoadId),
        method: GET
      })
    }),
    addCostRoad: builder.mutation({
      query: (data) => ({
        url: NetWork.costRoad,
        method: POST,
        data: data
      })
    }),
    updateCostRoad: builder.mutation({
      query: (data) => ({
        url: NetWork.costRoadId(data.id),
        method: PUT,
        data: data
      })
    }),
    deleteCostRoad: builder.mutation({
      query: (data: { ids: Array<number | string> }) => ({
        url: NetWork.costRoad,
        method: DELETE,
        data: data
        // invalidatesTags: [{ type: 'CostRoad', id: 'LIST' }] // Vô hiệu hóa tag 'CostRoad' với id 'LIST' để gọi lại getListCostRoad
      })
    }),
    changeStatusCostRoad: builder.mutation({
      query: (data: { costRoadId: number; params: { isActive: boolean } }) => ({
        url: NetWork.costRoadId(data.costRoadId),
        method: PATCH,
        params: data.params
      })
    })
  })
})

// Export hooks for usage in functional components
export const {
  useGetListCostRoadQuery,
  useDeleteCostRoadMutation,
  useAddCostRoadMutation,
  useGetCostRoadByIdQuery,
  useUpdateCostRoadMutation,
  useChangeStatusCostRoadMutation
} = costRoadApi
